Browser = require '@trello/browser'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_composer_inline')

module.exports = ->
  placeholder = t.mustacheVar('placeholder')
  distinctLists = t.mustacheVar('distinctLists')

  t.div '.list-card.js-composer', ->
    t.div '.list-card-details.u-clearfix', ->
      t.div '.list-card-labels.u-clearfix.js-list-card-composer-labels'
      t.textarea '.list-card-composer-textarea.js-card-title',
        { dir: 'auto', placeholder }, ->
          t.text (if Browser.browserVersionStr in ['explorer-10', 'explorer-11'] then placeholder else t.mustacheVar('title'))
      t.div '.list-card-members.js-list-card-composer-members'

  t.div '.cc-controls.u-clearfix', ->

    t.div '.cc-controls-section', ->
      t.input '.primary.confirm.mod-compact.js-add-card', { type: 'submit', value: t.l('add-card') }
      t.a '.icon-lg.icon-close.dark-hover.js-cancel', { href: '#' }

    t.div '.cc-controls-section.mod-right', ->
      t.a '.icon-lg.icon-overflow-menu-horizontal.dark-background-hover.js-cc-menu', { href: '#' }
